import type { Loop54ClientConfig } from "../loop54/client";
import type { EntityCollectionParameters, GenericFilter } from "../loop54/types";
import type { FilterAndSortParams, Locale } from "@agapi/mlc-core";

const getStoreFilterValue = (locale: Locale, config: Loop54ClientConfig) => {
  return config.marketIds[locale.country.toLocaleLowerCase()];
};

export const getBaseFilter = (params: FilterAndSortParams | undefined, locale: Locale, config: Loop54ClientConfig): EntityCollectionParameters => {
  const store = getStoreFilterValue(locale, config);
  const filters: GenericFilter[] = [];

  if (params?.filter?.length) {
    filters.push(...params.filter);
  }

  if (store) {
    filters.push({ type: 'attribute', attributeName: 'store', value: store });
  }

  if (locale.country) {
    filters.push({ type: 'attribute', attributeName: `price_amount_${locale.country}`, value: 0, comparisonMode: 'greaterThan' });
  }

  return { filter: filters.length < 2 ? filters[0] : { and: filters } };
};

export const getFacets = (params: FilterAndSortParams) => {
  return params.facetFilter ? {
    facets: Object.entries(params.facetFilter).map(([ key, value ]) => {
      return {
        name: key,
        attributeName: key,
        type: value.type,
        selected: value.values
      };
    })
  } : undefined;
};
